import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const BookingSection = () => (
  <section id="tournaments" className="py-24 bg-white">
    <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
      <span className="text-[#C9A96E] text-sm font-medium tracking-[0.2em] uppercase">
        Group Events
      </span>
      <h2 className="text-4xl font-serif font-bold text-[#1B2A4A] mt-3 mb-4">
        Golf Tournaments
      </h2>
      <p className="text-gray-500 mb-8 max-w-2xl mx-auto">
        Willow Ridge is the perfect venue for your next golf tournament.
        Our professional staff will help you plan every detail for a
        memorable event.
      </p>
      <p className="text-gray-600 mb-8">
        Contact <span className="font-semibold text-[#1B2A4A]">Chris Hill</span>,
        CPGA Golf Professional, to book your 2026 tournament.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 px-8 py-4 bg-[#1B2A4A] text-white font-semibold rounded-md hover:bg-[#2a3d62] transition-colors duration-300"
        >
          Inquire Now <ArrowRight size={18} />
        </Link>
        <Link
          to="/events"
          className="inline-flex items-center gap-2 px-8 py-4 border-2 border-[#1B2A4A] text-[#1B2A4A] font-semibold rounded-md hover:bg-[#1B2A4A] hover:text-white transition-all duration-300"
        >
          View Events
        </Link>
      </div>
    </div>
  </section>
);

export { BookingSection };
